// actions for campaign types: ie poll, ad, etc
import axios from 'axios'

const apiUrl = 'http://localhost:8080/campaign'
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS'
export const GET_CAMPAIGN = 'GET_CAMPAIGN'
export const SET_CAMPAIGN = 'SET_CAMPAIGN'

export const getCampaigns = () => {
  return (dispatch) => {
    return axios.get(`${apiUrl}`)
      .then(response => {
        dispatch({ type: GET_CAMPAIGNS, campaigns: response.data })
      })
      .catch(error => {
        console.log(`error getting campaigns: ${error}`)
      })
  }
}

export const getCampaign = (paramKey, paramVal) => {
  const config = {
    params: {
      [paramKey]: paramVal
    }
  }
  return (dispatch) => {
    return axios.get(`${apiUrl}`, config)
      .then(response => {
        dispatch({ type: GET_CAMPAIGN, campaign: response.data[0] })
      })
      .catch(error => {
        console.log(`error getting campaign: ${error}`)
      })
  }
}

export const setCampaign = (campaign_id) => {
  return (dispatch) => {
    return dispatch({ type: SET_CAMPAIGN, newCampaignId: campaign_id })
  }
}
